<template name="indexMessageList">
  <div>
    <div v-if="this.checkedMessageList.length || this.checkMessageList.length || this.todayMessageList.length">
      <!--checkMessage-->
      <div class="checkMessage" v-if="this.checkedMessageList.length || this.checkMessageList.length">
        <div class="row">
          <div class="col-8">
            {{$t('WaitingApproval')}}<span> ({{this.checkMessageList.length}})</span>
          </div>      
          <div class="col-4 checkMore" v-on:click="checkMore">
            {{$t('ViewMore')}} >
          </div>
        </div>
        <div class="today-dataList">
          <ul>
            <li v-for="(item, index) in this.checkMessageList" v-if="index < 5">
            <router-link :to="'/inviteDetail/' + item.ticketId">
              <div class="row">
                <div class="col-9">
                  <div class="top">
                    <span class="radius-list" ></span>
                    <span class="text">{{item.title}}</span>
                  </div>
                </div>
                <div class="col-3 col-status">
                  <span class="statuslist today-status">{{item.ticketStatusDesc}}</span>
                  </div>
                  </div>
                  <div class="bottom">
                  <div>
                  <i class="iconfont icon-shenfenzheng"></i>
                  <span>{{item.visitTicketUserRoleDesc}}</span>
                </div>
                <div>
                 <i class="iconfont icon-renyuanguanli"></i>
                 <span>{{item.visitorNumber}}{{ $t('People') }}</span>
               </div>
               <div>
                 <i class="iconfont icon-clock"></i>
                 <span>{{item.startTime}} - {{item.endTime}}</span>
               </div>
             </div>
           </router-link>
           </li>
         </ul>
       </div>
     </div>
     <!--todayMessage-->
     <div class="todayMessage" v-show="this.todayMessageList.length > 0">
      <div class="row">
        <div class="col-8">
          {{$t('TodayInvitation')}}<span> ({{this.todayNumber}})</span>
        </div>      
        <div class="col-4 checkMore" v-on:click="checkMoreToday">
          {{$t('ViewMore')}} >
        </div>
      </div>
      <div class="today-dataList">
        <ul>
          <li v-for="(item, index) in this.todayMessageList" v-if="index < 5">
            <router-link :to="'/inviteDetail/' + item.ticketId">
              <div class="row">
                <div class="col-9">
                  <div class="top">
                    <span class="radius-list" ></span>
                    <span class="text">{{item.title}}</span>
                  </div>
                </div>
                <div class="col-3 col-status">
                  <span class="statuslist today-status">{{item.ticketStatusDesc}}</span>
                  </div>
                  </div>
                  <div class="bottom">
                  <div>
                  <i class="iconfont icon-shenfenzheng"></i>
                  <span>{{item.visitTicketUserRoleDesc}}</span>
                </div>
                <div>
                 <i class="iconfont icon-renyuanguanli"></i>
                 <span>{{item.visitorNumber}}{{ $t('People') }}</span>
               </div>
               <div>
                 <i class="iconfont icon-clock"></i>
                 <span>{{item.startTime}} - {{item.endTime}}</span>
               </div>
             </div>
           </router-link>
         </li>
       </ul>
     </div>
   </div>
 </div>
 <!-- no message -->
 <div v-if="this.noVisitorInfo && this.todayMessageList.length < 1 && this.checkedMessageList.length < 1 ">
  <div  class="visitor-empty">
    <div class="icon"></div>
    <h5>{{$t('NoInvitation')}}</h5>
    <p>{{$t('NoinvitationToCreat')}}</p>
  </div>
</div>  
</div>
</template>

<script>
import { getInviteListByCheck, getInviteListByToday } from '@/utils/api';
import { checkNested } from '@/utils/utils';
export default {
  name: 'indexMessageList',
  data() {
    return {
      todayMessageList: [],
      checkMessageList: [],
      checkedMessageList: [],
      isTodayShow: false,
      isCheckShow: false,
      modalView: true,
      visitStatus: 1,
      todayNumber: 0,
      noVisitorInfo: false,
    }
  },
  created: function () {
    const that = this;
    that.getInviteListCheck().then(() => {
      that.getInviteListChecked();
    }).then(() => {
      that.getInviteListToday();
    }).then(() => {
      that.todayMessageList.length || that.checkedMessageList.length || that.checkMessageList.length ? this.noVisitorInfo = false : that.noVisitorInfo = true;
    })
  },
  mounted: function() {
  },
  methods: {
    checkMore: function() {
      this.$emit('getModalMessage', this.modalView);
      this.$emit('getType', 'check');
    },
    checkMoreToday: function() {
      this.$emit('getModalMessage', this.modalView);
      this.$emit('getType', 'today');
    },
    bindData: function(res, isMore) {
    },
    getInviteListCheck: function() {
      return new Promise(resolve => {
        getInviteListByCheck(1, 100, '', 0, 1).then((res) => {
          if (checkNested(res, 'data', 'content', 'model', 'entities')) {
            this.checkMessageList = res.data.content.model.entities;; 
            resolve(this.checkMessageList);
          }
        });
      })
      
    },
    getInviteListChecked: function() {
      return new Promise(resolve => {
        getInviteListByCheck(1, 100, '', 0, 2).then((res) => {
          if (checkNested(res, 'data', 'content', 'model', 'entities')) {
            this.checkedMessageList = res.data.content.model.entities;
            resolve(this.checkedMessageList)
          }
        });
      })
      
    },
    getInviteListToday: function() {
      let isMore = this.visitStatus != 1;
      return new Promise(resolve => {
        getInviteListByToday(1, 100, '', this.visitStatus, 0).then((res) => {
          if (checkNested(res, 'data', 'content', 'model', 'entities')) {
            let data = res.data.content.model.entities;
            if (isMore) {
              this.todayMessageList = [...this.todayMessageList, ...data];
              if (this.todayMessageList.length < 5 && this.visitStatus != 3) {
                this.visitStatus = 3;
                this.getInviteListToday();
              }  
            }  else {
              this.todayMessageList = data;
              if (this.todayMessageList.length < 5) {
                this.visitStatus = 2;
                this.getInviteListToday();
              }
            }
          }
        });
        getInviteListByToday(1, 100, '', 0, 0).then((res) => {
          if (checkNested(res, 'data', 'content', 'model', 'entities')) {
            //this.todayMessageList = res.data.content.model.entities;
            this.todayNumber = res.data.content.model.entities.length;
          }
        });
        //console.log(this.todayMessageList) 
        resolve(this.todayMessageList)
      })
    },
  },
}
</script>

<style scoped lang="scss">
.todayMessage,
.checkMessage {
  width: 100%;    
  & > div:first-child {
    // font-family: HiraginoSansGB-W6;
    font-size: 16px;
    color: #4a4a4a;
    margin-bottom: 20px;
    width: 90%;
    margin: auto;
    padding: 0;
    & > div:first-child {
      // font-family: HiraginoSansGB-W6;
      font-size: 16px;
      color: #212529;
      padding: 0;
      font-weight: bold;
    }
    .checkMore {
      cursor: pointer;
      color: #929292;
    }
    & > div:last-child {
      padding: 0;
      text-align: right;
      font-size: 13px;
      color: #929292;
      a {
        color: #929292;
      }
    }
  }
  .today-dataList {
    width: 90%;
    margin: auto;
    padding: 20px 0;
    ul {
      width: 100%;
      margin: 0 auto;
      list-style: none;
      li {
        width: 100%;
        margin: 0 auto;
        margin-bottom: 20px;
        border-radius: 4px;
        background-color: #ffffff;
        &:last-child {
          margin-bottom: 0;
        }
        div.row {
          margin: 0;
          width: 100%;
          margin: auto;
          .col-status {
            text-align: right;
          }
          & > div {
            padding: 0;
            .top {
              .radius-list {
                display: inline-block;
                margin-right: 7px;
                vertical-align: middle;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                background-color: #ff2137;
                border: 3px solid #ffe2ef;
              }
              .radius-list-out {
                display: inline-block;
                margin-right: 7px;
                vertical-align: middle;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                background-color: #919191;
                border: 3px solid #e6e6e6;
              }
              .text {
                font-weight: bold;
                font-size: 14px;
                color: #4a4a4a;
              }
            }              
          }
          & > div:last-child {
            .today-status {
              display: inline-block;
              color: #e42029;
              font-size: 12px;
              font-weight: bold;
            }
            .today-status-out {
              display: inline-block;
              color: #929292;
              font-size: 12px;
              font-weight: bold;
            }
          }
        }
        .bottom {
          display: flex;
          padding-top: 5px;
          flex-wrap: wrap;
          div {
            padding-right: 8px;
          }
          i {
            font-size: 14px;
            color: #e42029;
          }
          span {
            font-size: 12px;
            color: #929292;
            padding-left: 5px;
          }
        }
      }
    }
    a {
      color: #212529;
      display: block;
      text-decoration: none;
      border-radius: 4px;
      background: #fff;
      padding: 15px 12px;
      box-shadow: 0 0 25px rgba(100, 100, 100, 0.3);
    }
  }
}
.statuslist  {
  word-break: break-word;
}
.visitor-empty {
  padding-top: 60px;
  text-align: center;
  height: 200px;
  .icon {
    width: 86px;
    height: 86px;
    margin: 0 auto 15px;
    background: url('../assets/images/black-01.png') no-repeat;
  }
  h5,
  p {
    font-size: 13px;
  }
  h5 {
    font-weight: bold;
  }
}
</style>